export default __webpack_public_path__ + "static/member8-14629a61d4cc4decc38ba24190ad0f70.jpg";